export default "__VITE_ASSET__310653ba__"